import React, { Component, createRef } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { retrieveProductCache } from '../../actions/checkout';
import { searchInput, goToPage } from '../../actions/environment';
import { translate, prefix } from '../../utils/locale';
import s from './SearchForm.scss';

class SearchForm extends Component {
	constructor(props) {
		super(props);

		this.debounceTimer = false;
		this.inputElement = createRef();
	}

	componentDidMount() {
		if (this.searchForm) this.searchForm.querySelector('input').focus();
	}

	searchHandler = (e) => {
		e.preventDefault();
	};

	triggerSearchEvent = (value) => {
		if (typeof window !== 'undefined') {
			if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
			if (value.length > 3) {
				window.dataLayer.push({
					event: 'Search',
					values: {
						language: this.props.setup.language,
						search_string: value.toLowerCase(),
					},
				});
			}
		}
	};

	onSearchInputChange = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		const { value = '' } = $input;

		this.props.searchInput(value);

		clearTimeout(this.debounceTimer);
		this.debounceTimer = setTimeout(() => {
			this.triggerSearchEvent(value);
		}, 300);

		if (typeof window !== 'undefined') window.history.replaceState({}, '', prefix(this.props.setup, `search${value.length > 0 ? '?q=' : ''}${value.toLowerCase().replace(/\s/g, '+')}`));
	};

	onSearchInputBlur = () => {
		const { setup, location, searchInputText } = this.props;
		if (searchInputText === '' && location.type === 'SEARCH') {
			const searchReturn = location.prev && location.prev.type !== 'SEARCH' && location.prev.pathname ? location.prev.pathname : '/';
			this.props.goToPage(searchReturn.replace(prefix(setup, ''), ''));
		}
	};

	onSearchKeyPress = (e) => {
		if (e.key === 'Escape') {
			this.onSearchInputBlur();
			e.currentTarget.blur();
		}
	};

	render() {
		const { setup, searchInputText = '' } = this.props;

		return (
			<form className={s.searchForm} ref={(form) => { this.searchForm = form; }} onSubmit={this.searchHandler}>
				<h1 className={s.searchForm_heading}>{ `${translate(setup, 'searchingFor')}:` }</h1>
				<div className={s.searchForm_input}>
					<input id="search" ref={this.inputElement} className={s.searchForm_input_field} type="text" value={searchInputText} onChange={this.onSearchInputChange} onBlur={this.onSearchInputBlur} onKeyDown={this.onSearchKeyPress} />
					<span className={s.searchForm_input_underline} aria-hidden="true">{searchInputText || ' '}</span>
				</div>
				<button className={s.searchForm_submit} type="submit" aria-hidden aria-labelledby="Submit search" style={{ display: 'none' }} />
			</form>
		);
	}
}

const mapState = ({ environment, productCache, filtering }) => ({
	setup: environment.setup,
	searchInputText: environment.searchInputText,
	productCache,
	filtering,
});

export default hot(module)(connect(mapState, { searchInput, goToPage, retrieveProductCache })(SearchForm));
